import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const bookStack = defineConnector({
  identifier: "bookStack",
  name: "BookStack",
  tagLine: "Documentation and wiki platform",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.secret.tokenId}:${app.secret.tokenSecret}`,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In BookStack, go to your user profile and select **API Tokens → Create Token**.",
        },
      ],
    },
    {
      title: "Enter your BookStack details",
      items: [
        {
          kind: "baseUrl",
          label: "BookStack instance URL",
          required: true,
          placeholder: "https://bookstack.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your BookStack instance.",
        },
        {
          kind: "input",
          label: "Token ID",
          required: true,
          target: { kind: "secrets", field: "tokenId" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/docs.json`,
  },
});
